import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
import { Observable } from "rxjs";
import { Store } from "@ngrx/store";
import { selectSession } from "@core/store";
import { Session } from "@core/models";
import { RouterOutlet } from "@angular/router";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent implements OnInit {
  isIframe = false;
  public session$: Observable<Session>;

  constructor(
    private translationService: TranslateService,
    private title: Title,
    private store: Store
  ) {
    this.session$ = this.store.select(selectSession);
    // Set language based on browser preference, fallback to 'en'
    const browserLang = this.translationService.getBrowserLang() || "en";
    this.translationService.use(
      browserLang && browserLang.match(/en|de|fr|it/) ? browserLang : "en"
    );
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.translationService.get("page_title").subscribe((translation) => {
      this.title.setTitle(translation);
    });
  }
}
